/* */
 
import { put, takeLatest, select, takeEvery } from 'redux-saga/effects';
import uniqBy from 'lodash/uniqBy';

import OfferServices from 'services/OfferServices';
import types from 'redux/types';
import hooks from 'hooks';
import { getNextDataRefetch, isDefine } from 'helpers';
import { getError, showError } from 'helpers/handleError';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { parseDomainObjToString } from 'helpers/domain';
import { pageSize } from 'consts/filters';
import { AppRoutes } from 'consts/routesPath';

const { Notification } = hooks;

function* getListOffer(data) {
  let offset = data.offset;
  let url = data.url;
  let title = data.title;
  try {
    if (!isDefine(offset)) {
      offset = yield select((state) => state.filterReducer.filterOffers.offset);
    }
    if (!isDefine(url)) {
      url = yield select((state) => state.filterReducer.filterOffers.url);
    }
    if (!isDefine(title)) {
      title = yield select((state) => state.filterReducer.filterOffers.title);
    }

    const res = yield OfferServices.getList({ offset, url, title });
    yield put({
      type: types.REQUEST_GET_LIST_OFFER_SUCCESS,
      data: res.data.data,
      isLast: res.data.data.length < 5 || res.data.data.length <= 0,
    });
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_GET_LIST_OFFER_FAILED, error });
    yield put({ type: types.REQUEST_FILTER_OFFERS_FAILED });
  }
}

function* refetchListOffers() {
  try {
    const title = yield select((state) => state.filterReducer.filterOffers.title);
    const message = yield select((state) => state.filterReducer.filterOffers.message);
    const page = yield select((state) => state.filterReducer.filterOffers.page);

    // list Request
    let listRequest = [];
    for (let i = 0; i < page; i++) {
      const newOffset = i * pageSize;
      listRequest = [...listRequest, OfferServices.getList({ offset: newOffset, title, message })];
    }

    const response = yield Promise.all(listRequest);
    const [nextData, isLast] = getNextDataRefetch(response, pageSize, 'data');
    yield put({ type: types.REQUEST_GET_LIST_OFFER_SUCCESS, data: nextData, isLast });
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_GET_LIST_OFFER_FAILED, error });
  }
}

function* filterOffers(data) {
  let { resetForm } = data;
  try {
    yield put({ type: types.REQUEST_FILTER_OFFERS });
    const offset = yield select((state) => state.filterReducer.filterOffers.offset);
    const url = yield select((state) => state.filterReducer.filterOffers.url);
    const title = yield select((state) => state.filterReducer.filterOffers.title);
    const res = yield OfferServices.getList({ offset, title, url });

    let listOffer;
    if (offset != 0) {
      listOffer = yield select((state) => state.offerReducer.listOffer);
      listOffer = uniqBy([...listOffer, ...res.data.data], 'id');
    } else listOffer = res.data.data;

    if (resetForm) resetForm();
    yield put({
      type: types.REQUEST_FILTER_OFFERS_SUCCESS,
      listOffer,
      isLast: res.data.data.length <= 0 || res.data.data.length < 5,
    });
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_FILTER_OFFERS_FAILED, error });
  }
}

function* createOffer(data) {
  const { bodyRequest, history, callbacks } = data;
  try {
    const userId = yield select((state) => state.userServletReducer.data.id);
    const res = yield OfferServices.create({
      ...bodyRequest,
      domain: parseDomainObjToString(bodyRequest?.domain),
      userId,
    });

    if (res.data.code && res.data.code === 400) {
      let error = res.data.message;
      showError(error);
      yield put({ type: types.REQUEST_CREATE_OFFER_FAILED, error });
      return;
    }

    yield refetchListOffers();
    yield put({ type: types.REQUEST_CREATE_OFFER_SUCCESS });
    Notification('success', 'Create offer successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
    yield history.push(AppRoutes.Offers);
  } catch (error) {
    const messageError = getError(error);
    showError(messageError);
    yield put({ type: types.REQUEST_CREATE_OFFER_FAILED, error });
    callbacks && callbacks.onFailed();
  }
}

function* getOfferById(data) {
  const { id } = data;
  try {
    const userId = yield select((state) => state.userServletReducer.data.id);
    const res = yield OfferServices.getById({ id, userId });
    if (res?.data?.code === 400) {
      showError(res?.data?.message);
      yield put({ type: types.REQUEST_GET_OFFER_BY_ID_FAILED, error: res?.data?.message });
      return;
    }

    if (typeof res.data === 'object') {
      let listOffer = yield select((state) => state.offerReducer.listOffer);
      const index = listOffer.findIndex((el) => el.id.toString() === id.toString());
      listOffer[index] = res.data;
      yield put({ type: types.REQUEST_GET_OFFER_BY_ID_SUCCESS, data: res.data, listOffer });
    }
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_GET_OFFER_BY_ID_FAILED,
      error: error.response.statusText || 'Something went wrong!',
    });
  }
}

function* updateOffer(data) {
  const { bodyRequest, callbacks } = data;
  try {
    const userId = yield select((state) => state.userServletReducer.data.id);
    const id = bodyRequest?.id;

    const res = yield OfferServices.update({
      ...bodyRequest,
      userId,
      domain: parseDomainObjToString(bodyRequest?.domain),
    });

    const listOffer = yield select((state) => state.offerReducer.listOffer);
    const index = listOffer.findIndex((el) => el.id.toString() === id.toString());
    if (~index) {
      listOffer[index] = {
        ...listOffer[index],
        ...res.data,
        domains: res.data.domains || listOffer[index].domains,
        domain: res.data.domain || listOffer[index].domain,
      };
    }

    Notification('success', 'Update offer successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
    yield put({ type: types.REQUEST_UPDATE_OFFER_SUCCESS, listOffer, offer: res.data });
    callbacks && callbacks.onSuccess();
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_UPDATE_OFFER_FAILED, error });
    callbacks && callbacks.onFailed();
  }
}

function* deleteOffer(data) {
  const { listOfId, resetCheckList, setLoading, toggle } = data;
  try {
    const userId = yield select((state) => state.userServletReducer.data.id);
    const listRequest = listOfId.map((id) => OfferServices.delete({ id, userId }));
    const res = yield Promise.all(listRequest);

    const checkFail = res.some((el) => el.data.message.toLowerCase() !== 'ok');

    if (res.some((el) => el.data.message.toLowerCase() === 'ok')) {
      yield refetchListOffers();
    }

    /** Check if fail */
    if (checkFail) {
      let stopLoop = true;
      res.forEach((i) => {
        if (stopLoop && i.data.message.toLowerCase() !== 'ok') {
          stopLoop = true;
          showError(i.data.message);
          setLoading(false);
          resetCheckList();
          toggle();
        }
      });
      return;
    }

    yield put({ type: types.REQUEST_DELETE_OFFER_SUCCESS });
    yield resetCheckList();
    yield toggle();
    Notification('success', 'Delete offer successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_DELETE_OFFER_FAILED, error });
    setLoading(false);
  }
}

function* updateOfferCampaign(data) {
  const { id, status, cpId, callbacks = {} } = data;
  try {
    const userId = yield select((state) => state?.userServletReducer?.data?.id);
    const res = yield OfferServices.updateOfferCampaign({ id, status, userId });
    if (res?.data?.code && res?.data?.code >= 300) {
      const message = res.data.message;
      showError(message);
      yield put({ type: types.REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED, message, id });
      callbacks && callbacks.onFailed(message);
    } else {
      callbacks && callbacks.onSuccess();
      Notification(
        'success',
        'Change status creative successfully!',
        'Success',
        TIME_OUT_CLOSE_TOAST
      );
      yield put({
        type: types.REQUEST_UPDATE_OFFER_CAMPAIGN_SUCCESS,
        cpId,
        id,
        offer: res.data,
      });
    }
  } catch (error) {
    const { body } = error?.response?.data || {};
    const { message } = body || {};
    if (message) {
      showError(message);
    } else {
      showError(error);
    }

    callbacks && callbacks.onFailed(error);
    yield put({ type: types.REQUEST_UPDATE_OFFER_CAMPAIGN_FAILED, error, id });
  }
}

function* updateDomainCampaign(data) {
  const { id, status, cpId, callbacks } = data;
  try {
    const res = yield OfferServices.updateDomainCampaign({ id, status });
    if (res.data.code && res.data.code >= 300) {
      const message = res.data.message;
      showError(message);
      yield put({ type: types.REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED, message, id });
      callbacks && callbacks.onFailed();
    } else {
      Notification(
        'success',
        'Change status creative successfully!',
        'Success',
        TIME_OUT_CLOSE_TOAST
      );
      yield put({
        type: types.REQUEST_UPDATE_DOMAIN_CAMPAIGN_SUCCESS,
        cpId,
        id,
        domainGroup: res.data,
      });
      callbacks && callbacks.onSuccess();
    }
  } catch (error) {
    const { body } = error.response.data;
    const { message } = body;
    showError(message);
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_UPDATE_DOMAIN_CAMPAIGN_FAILED, error, id });
  }
}

export default function* watchAPIFunction() {
  yield takeLatest(types.REQUEST_CREATE_OFFER, createOffer);
  yield takeLatest(types.REQUEST_GET_LIST_OFFER, getListOffer);
  yield takeLatest(types.REQUEST_GET_OFFER_BY_ID, getOfferById);
  yield takeLatest(types.REQUEST_UPDATE_OFFER, updateOffer);
  yield takeLatest(types.REQUEST_DELETE_OFFER, deleteOffer);
  yield takeLatest(types.CHANGE_FILTER_OFFERS, filterOffers);
  yield takeEvery(types.REQUEST_UPDATE_OFFER_CAMPAIGN, updateOfferCampaign);
  yield takeEvery(types.REQUEST_UPDATE_DOMAIN_CAMPAIGN, updateDomainCampaign);
}
